module.exports = __webpack_public_path__ + "src/assets/img/stamp.7c597fd6.png";